<template>
  <hm-content title="修改密码">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="原密码：" prop="password">
        <el-input
          type="password"
          v-model="ruleForm.password"
          clearable
          placeholder="原密码"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="现密码：" prop="newPwd">
        <el-input
          type="password"
          v-model="ruleForm.newPwd"
          clearable
          placeholder="新密码"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="现密码：" prop="newPassword">
        <el-input
          type="password"
          v-model="ruleForm.newPassword"
          placeholder="确认密码"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <div class="flex flex-center">
        <el-button
          type="primary"
          size="small"
          @click="submitRuleForm('ruleForm')"
          >修改</el-button
        >
        <el-button size="small" @click="back">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>

<script>
 import { mapGetters } from "vuex";
import { getLoginUser, getToken } from "@/utils/auth";

export default {
    
  data() {
    const validatorFunc = function(rule, val, callback) {
      if (this.ruleForm.newPassword === this.ruleForm.newPwd) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);
    return {
      account: "",
      ruleForm: {
        password: "",
        newPwd: "",
        newPassword: ""
      },
      rules: {
        password: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur"
          },
          { min: 6, message: "长度不能小于6个字符", trigger: "blur" },
          { max: 12, message: "长度在12个字符内", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        newPwd: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          },
          { min: 6, message: "长度不能小于6个字符", trigger: "blur" },
          { max: 12, message: "长度在12个字符内", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
          { min: 6, message: "长度不能小于6个字符", trigger: "blur" },
          { max: 12, message: "长度在12个字符内", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters(["staffList"]),
  created() {},
  mounted() {
    this.account = getLoginUser().account;
    // this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  watch: {},
  methods: {
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$store
            .dispatch("modifyPassword", {
              account: this.account,
              password: this.ruleForm.password,
              newPassword: this.ruleForm.newPassword
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  type: "success",
                  message: "修改成功！"
                });
                this.resetForm(formName);
                this.$store.dispatch("LogOut", getToken()).then(() => {
                  location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    back() {
      this.$router.back(-1);
    },
    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
